type MetricsType = {
  itemsDiscardedByRetry: number;
  duplicateEventCount: number;
  eventCount: number;
  localstorageDuplicateCount: number;
  itemsDiscardedByOverflow: number;
  resilienceMechanism: string;
};

export class MetricsCollector {

  // Number of events discarded due to exceeding retry limits.
  private itemsDiscardedByRetry: number = 0;

  // Duplicates caught by us.
  private duplicateEventCount: number = 0;

  // Number of events created by the product in current tab.
  private eventCount: number = 0;

  // Duplicates caught by @segment/localstorage-retry
  private localstorageDuplicateCount: number = 0;

  // Number of events discarded due to reaching queue max size.
  private itemsDiscardedByOverflow: number = 0;

  // Will be used in the future when we get more resilience mechanisms
  private resilienceMechanism: string = '@segment/localstorage-retry';

  addToItemsDiscardedByRetryCounter() {
    this.itemsDiscardedByRetry++;
  }

  addToDuplicateEventCounter() {
    this.duplicateEventCount++;
  }

  addToEventCount() {
    this.eventCount++;
  }

  addToLocalstorageDuplicateCount() {
    this.localstorageDuplicateCount++;
  }

  addToItemsDiscardedByOverflowCounter() {
    this.itemsDiscardedByOverflow++;
  }

  subtractFromMetrics(sentMetrics: MetricsType) {
    this.itemsDiscardedByRetry = Math.max(this.itemsDiscardedByRetry - sentMetrics.itemsDiscardedByRetry, 0);
    this.duplicateEventCount = Math.max(this.duplicateEventCount - sentMetrics.duplicateEventCount, 0);
    this.eventCount = Math.max(this.eventCount - sentMetrics.eventCount, 0);
    this.localstorageDuplicateCount = Math.max(this.localstorageDuplicateCount - sentMetrics.localstorageDuplicateCount, 0);
    this.itemsDiscardedByOverflow = Math.max(this.itemsDiscardedByOverflow - sentMetrics.itemsDiscardedByOverflow, 0);
  }

  getMetricsPayload(): MetricsType {
    return {
      itemsDiscardedByRetry: this.itemsDiscardedByRetry,
      duplicateEventCount: this.duplicateEventCount,
      eventCount: this.eventCount,
      localstorageDuplicateCount: this.localstorageDuplicateCount,
      itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
      resilienceMechanism: this.resilienceMechanism,
    }
  }
}

let cachedMetricsClient: MetricsCollector | null = null;

export default (): MetricsCollector => {
  if (!cachedMetricsClient) {
    cachedMetricsClient = new MetricsCollector();
  }
  return cachedMetricsClient;
}
